<template>
  <div style="min-height">
    <div class="row mb-4">
      <div class="col-6 col-md-9 text-left">
        {{ $t('ui_searchResults') }}: {{ pageStart + 1 }}-{{ pageMax }}
        {{ $t('ui_searchTotal') }}: {{ rows }}
      </div>
      <div class="col-6 col-md-3 text-right">
        <b-input
          :value="searchStr"
          @input="$emit('update:searchStr', $event)"
          :placeholder="$t('ui_searchPlaceholder') + '...'"
        ></b-input>
      </div>
    </div>
    <slot :items="displayedRows"></slot>
    <div class="row w-100">
      <div class="col-3" v-if="false">
        <multiselect
          placeholder=""
          :allowEmpty="false"
          v-model="selectedPerPage"
          :options="perPageOptions"
          track-by="Id"
          label="Nev"
          :searchable="false"
        >
        </multiselect>
      </div>
      <div class="col-12">
        <b-pagination
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
          align="right"
          hide-ellipsis
          class="mt-0"
          :limit="3"
        >
          <!-- <template v-slot:first-text
            >First</template
          >
          <template v-slot:prev-text
            ><i class="fa fa-angle-left mt-1"> </i
          ></template>
          <template v-slot:next-text
            ><i class="fa fa-angle-right mt-1"> </i
          ></template>
          <template v-slot:last-text
            >Last</template
          > -->
          <template v-slot:first-text>
            <i class="fa fa-angle-double-left mt-1"> </i>
          </template>
          <template v-slot:prev-text>
            <i class="fa fa-angle-left mt-1"></i>
          </template>
          <template v-slot:next-text>
            <i class="fa fa-angle-right mt-1"> </i>
          </template>
          <template v-slot:last-text>
            <i class="fa fa-angle-double-right mt-1"> </i>
          </template>
        </b-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'table-with-pagination',
  data() {
    return {
      selectedPerPage: { Id: 9, Nev: '9' },
      currentPage: 1,
    };
  },
  computed: {
    perPageOptions() {
      return [
        { Id: 10, Nev: '10' },
        { Id: 20, Nev: '20' },
        { Id: 50, Nev: '50' },
        { Id: -1, Nev: this.$t('ui_searchAll') },
      ];
    },
    rows() {
      return this.items.length;
    },
    pageStart() {
      if (this.perPage < 0) {
        return 1;
      }
      return this.pageEnd - this.perPage;
    },
    pageEnd() {
      if (this.perPage < 0) {
        return 1;
      }
      return this.currentPage * this.perPage;
    },
    pageMax() {
      if (this.perPage < 0) {
        return 1;
      }
      return Math.min(this.pageEnd, this.rows);
    },
    displayedRows() {
      if (this.perPage < 0) {
        return this.items.slice();
      }
      return this.items.slice(this.pageStart, this.pageEnd);
    },
    perPage() {
      if (this.selectedPerPage.Id < 0) {
        return this.rows;
      }
      return this.selectedPerPage.Id;
    },
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    searchStr: {
      type: String,
    },
  },
};
</script>
